<template>
  <div >

    <table class="table table-responsive" v-if="races.length > 0 && dataLoaded">
      <thead >
        <tr>
          <th scope="col">Id</th>
          <th scope="col">Predicted Winner</th>
          <th scope="col"> Location</th>
          <th scope="col">Actual Winner</th>
          <th scope="col"></th>
          <th scope="col">Notes</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="race in races">
          <td class="clickable" @click="showRaceDetail(race)">{{race._id}}</td>
          <td >
            <span style="font-size:16px"><b-badge v-if="raceMeetsBetCriteria(race)"  v-b-tooltip.hover title="should bet" variant="success"><span>{{race.predictedWinner}}</span></b-badge></span>
            <span v-if="!raceMeetsBetCriteria(race)"> {{race.predictedWinner}} </span>
          </td>
          <td>{{race.location}}</td>
          <td>{{race.actualWinner}}</td>
          <td>
            <b-button @click="predict(race)">
              <span v-if="!race.loading">Predict</span>
              <b-spinner v-if="race.loading" variant="success" label="Spinning"></b-spinner>
            </b-button>
          </td>
          <td>
            <div><b-badge v-if="!race.isHandicap"  v-b-tooltip.hover title="7-13 furlongs" variant="warning">
              <span><del>hcap</del></span>
            </b-badge></div>
            <div><b-badge v-if="race.raceType === 'hurdle' || race.raceType === 'flat'"  v-b-tooltip.hover title="" variant="info"><span>{{race.raceType}}</span></b-badge></div>
            <div><b-badge  v-if="!race.isHandicap && (race.raceType === 'hurdle' || race.raceType === 'flat')" v-b-tooltip.hover title="" variant="light"><span>{{race.experienceCategory}}</span></b-badge></div>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
import RaceList from '../models/RaceList'
import * as PredictionClient from '../clients/PredictionClient'
export default {
  name: 'PredictionTable',
  props:   {
    'dateNumber' : Number
  },
  components: {
  },
  data () {
    return {
      title: 'PredictionTable',
      dataLoaded: false,
      raceList: {},
      races: [],
      loadingRaces: {}
    }
  },
  watch: {
    dateNumber: function() {
      this.loadRaces()
    }
  },
  methods: {
    raceMeetsBetCriteria (race) {
      return race.meetsBetCriteria()
      /*if (race.type === 'flat') return !race.isHandicap && race.distanceInFurlongs >= 7 && race.distanceInFurlongs <=13
      if (race.type === 'jumps') return !race.isHandicap */
    },
    showRaceDetail: function(race) {
      this.$router.push({name:"RacePage", params:{raceId:race._id}})
      this.$emit('raceSelected', race)
    },
    loadRaces: async function() {
      this.$emit('races', undefined)
      this.dataLoaded = false
      this.raceList = new RaceList()
      try {
        await this.raceList.load(this.dateNumber)
        if (this.raceList.loaded) {
          this.races = this.raceList.races
          this.dataLoaded = true
          this.$emit('races', this.races)
        }
      }catch (err){
        this.$emit('racesError', err)
      }
    },
    predict: function (race) {
      race.loading = true
      this.races = []
      this.races = this.raceList.races
      return race.predict()
      .then(() => {
        this.races = []
        this.races = this.raceList.races
      })
    }
  },
  mounted () {
    this.dataLoaded = false
    this.loadRaces()
  }
}

function average(array) {
  if (array) {
    const sum = array.reduce((a, b) => a + b, 0);
    return (sum / array.length) || 0;
  }else {
    return 0
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nameCell {
  font-size: 10pt
}

.green {
  background-color: green
}
</style>
